import React from 'react'

import Logo from 'presentation/shared/components/Logo'
import * as S from './styles'
import SecretarySignupForm, {
  SecretarySignupFormValues
} from 'presentation/secretary/components/Forms/Signup'
import { FinishSecretarySignup } from 'domain/usecases/secretary/finish-secretary-signup'

type SecretarySignupLayoutProps = {
  initialValues?: SecretarySignupFormValues
  finishSecretarySignup?: FinishSecretarySignup
  token?: string
}

export default function SecretarySignupLayout({
  initialValues,
  finishSecretarySignup,
  token
}: SecretarySignupLayoutProps) {
  return (
    <S.Wrapper>
      <S.Header>
        <Logo
          size="huge"
          style={{
            display: 'inline-block'
          }}
        />
      </S.Header>
      <SecretarySignupForm
        finishSecretarySignup={finishSecretarySignup}
        initialValues={initialValues}
        token={token}
      />
    </S.Wrapper>
  )
}
